import type { Command } from '@blocksuite/std';
import { type BlockModel, type DraftModel, Slice } from '@blocksuite/store';

import {
  beginDatabaseCut,
  type DatabaseCut,
} from '../../adapters/middlewares/database-clipboard';

export const copySelectedModelsCommand: Command<{
  draftedModels?: Promise<DraftModel<BlockModel<object>>[]>;
  /** Runs after the copy; a cut receives its database cut. */
  onCopy?: (cut?: DatabaseCut) => void;
  databaseCut?: boolean;
}> = (ctx, next) => {
  const models = ctx.draftedModels;
  if (!models) {
    console.error(
      '`draftedModels` is required, you need to use `draftSelectedModels` command before adding this command to the pipeline.'
    );
    return;
  }

  models
    .then(async models => {
      const slice = Slice.fromModels(ctx.std.store, models);
      const cut = ctx.databaseCut
        ? beginDatabaseCut(ctx.std.store, models)
        : undefined;
      cut?.markSlice(slice);
      try {
        await ctx.std.clipboard.copy(slice);
        ctx.onCopy?.(cut);
        cut?.complete();
      } catch (error) {
        cut?.abort();
        throw error;
      }
    })
    .catch(console.error);
  return next();
};
